const filterConfig = {
  type: 'object',
  properties: {
      event_rule_id: {
        type: 'integer'
      },
      search: {
          type: 'string',
      },
    }
}
const getFiltersConfig: any = (type: string) => {
  return filterConfig;
}
export default getFiltersConfig;